<div class="contenedorInt">
    <div id="FcarouselHome" class="carousel slide" data-ride="carousel">
        <carousel>
            <slide *ngFor="let slider of sliders let i = index;">
                <a href="{{slider.url}}" target="_blank" rel="noopener">
                    <!-- <img src="{{slider.image}}" alt="{{slider.descripcion}}" style="display: block; width: 100%;"> -->
                    <picture>
                        <source media="(max-width: 767px)" type="image/webp" srcset="https://fundacionbest.org.mx/{{slider?.imgMovilWebp}}">
                        <source media="(min-width: 768px)" type="image/webp" srcset="https://fundacionbest.org.mx/{{slider?.imgDeskoptWebp}}">
                        <source media="(max-width: 767px)" type="image/jpeg" srcset="https://fundacionbest.org.mx/{{slider?.imgMovil}}">
                        <source media="(min-width: 768px)" type="image/jpeg" srcset="https://fundacionbest.org.mx/{{slider?.imgDeskopt}}">
                        <img src="{{slider?.imgDeskopt}}" alt="{{slider?.descripcion}}" class="slides">
                    </picture>
                </a>
            </slide>
        </carousel>
    </div>
    <section class="Ffrase dNueve dmOnce flx">
        <div class="dOcho dtDiez dmDoce">
            <p class="FpFrase">En</p>
            <div id="logoBestH"><img src="./assets/images/fundacionBest-logo-horizontal.png" alt="Fundación Best"></div>
            <p>nuestro lema es <span>“Para ayudar a los que menos tienen”</span>, por ello ofrecemos consulta médica y odontológica con <b>calidad y calidez.</b></p>
            <button type="button" class="btn" (click)="getQuienesSomos()">CONOCE MÁS AQUÍ</button>
        </div>
    </section>
    <!-- Dinamico -->
    <!--
    <section class="Fcifras">
        <div id="backRepublica">
            <img src="./assets/images/mapaRepublica.jpg" alt="mapa de la república México" id="mapaRdesktop"/>
            <img src="./assets/images/mapaRepublicaMovil.jpg" alt="mapa de la república México" id="mapaRmobile"/>
            <div class="FcifrasInt flx">
                <div class="dDoce">
                    <h1>FUNDACIÓN BEST <span>EN CIFRAS</span></h1>
                </div>
                <div class="dTresM dmDoce" *ngFor="let cifra of cifras">
                    <div class="FcifrasDatos" [innerHTML]="cifra.cantidad"></div>
                    <p [innerHTML]="cifra.concepto"></p>
                </div>
            </div>
        </div>
    </section>
    -->
    <section class="Fcifras">
        <a href="https://mividaeslucha.com/" target="_blank"  rel="noopener">
            <img src="./assets/images/banner_mi_vida_es_lucha.jpg" class="" alt="Conciencia médica" />
        </a>
    </section>
    <section class="Fgaceta">
        <div class="FgacetaInt dNueve dmOnce flx maxCnt">
            <div class="dSiete dmDoce">
                <p>La gaceta médica ConCiencia Médica publica información amplia en el campo de la medicina, así como proporciona información actualizada y relevante para el área de la salud.</p>
                <button type="button" class="btn"><a href="https://fundacionbest.org.mx/gaceta-medica/index.html" target="_blank" rel="noopener">HAZ CLIC</a></button>
            </div>
            <div class="dCinco dmOnce">
                <img src="./assets/images/gacetaMedica.png" alt="Conciencia médica" />
            </div>
        </div>
    </section>
    <section class="Fnoti dDiez dtOnce dmDoce flx maxCnt">
        <h3 class="dDoce">CUIDA TU SALUD</h3>
            <div class="dCuatro Fnota" id="FnotiInt" *ngFor="let nota of notas;" >
                <a  [routerLink]="'/nota/' + nota.url " class="notalnk">
                <div class="FnotiImg">
                    <img src="{{nota?.urlimagen}}" alt="{{nota?.titulo}}" />
                </div>
                <div class="FnotaTexto">
                    <h4 innerHtml="{{nota?.titulo}}"></h4>
                    <hr />
                    <p innerHtml="{{nota?.intro}}"></p>
                </div>
            </a>
            </div>
    </section>
</div>

<div class="politica-cookies" *ngIf="mostrarBanner">
    <button class="cerrar-banner" (click)="aceptarCookies()">✕</button>
    <br>
    <p><strong>Política de Cookies</strong> <br>
    En esta página web utilizamos cookies propias y de terceros para fines técnicos, de preferencias, análisis y publicidad, para brindarte una mejor experiencia en el uso de nuestro sitio web. Si continúa navegando, acepta su uso. 
    Para más información consulta nuestra <a routerLink="politica-de-cookies">Política de Cookies. </a>
    </p>
    
        <div class="boton-cookies">
            <button class="politica-aceptada" (click)="aceptarCookies()">Aceptar</button>
        </div>
    
    
</div>

<!---<ng-template #template>
  <div class="modal-header p-0">
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pt-0 m-0">
     <img src="assets/images/popups/simimeti-popup-farmacias.jpg" alt="simimeti" width="100%">
  </div>
</ng-template>--->
